import { crudPage } from '../ui/crud.js';
import { badgeStatus } from '../ui/badges.js';
import { el } from '../lib/dom.js';
import { supabase } from '../config/supabaseClient.js';
import { buscaSelect } from '../ui/buscaSelect.js';
import { abrirModal } from '../ui/modal.js';
import { toast } from '../lib/toast.js';
import { ehGestaoAtivo } from '../lib/permissoes.js';

const OPCOES_STATUS = [{ value: 'ATIVO', label: 'Ativo' }, { value: 'INATIVO', label: 'Inativo' }];

/** Anexa _count (nº de colaboradores) a cada empregador, via RPC empregador_contagem. */
async function enriquecerContagem(linhas) {
  const { data, error } = await supabase.rpc('empregador_contagem');
  if (error) { console.error('[empregador_contagem]', error.message); return; }
  const mapa = new Map((data || []).map((r) => [r.empregador_id, Number(r.total)]));
  linhas.forEach((l) => { l._count = mapa.get(l.id) || 0; });
}

async function buscarOutrosEmpregadores(termo, exclui) {
  let q = supabase.from('empregador').select('id, empresa').eq('status', 'ATIVO').neq('id', exclui);
  if (termo) q = q.ilike('empresa', `%${termo}%`);
  const { data } = await q.order('empresa').limit(30);
  return (data || []).map((e) => ({ value: e.id, label: e.empresa }));
}

/** Inativar empresa, opcionalmente reatribuindo todos os colaboradores a uma empresa substituta. */
function inativarSubstituir(emp, api) {
  const n = emp._count || 0;
  const picker = buscaSelect({ buscar: (t) => buscarOutrosEmpregadores(t, emp.id) });
  abrirModal({
    titulo: 'Inativar empresa',
    corpo: [
      el('p', { class: 'view__sub', style: 'margin-top:0', text: `Inativar "${emp.empresa}". Esta empresa tem ${n} colaborador(es) cadastrado(s).` }),
      el('p', { class: 'view__sub', style: 'margin:0 0 10px', text: 'Se houver empresa substituta (ex.: troca de terceirizada), escolha abaixo para reatribuir TODOS os colaboradores a ela. Deixe em branco se não houver.' }),
      el('div', { class: 'campo' }, [el('label', { text: 'Empresa substituta (opcional)' }), picker.elemento]),
    ],
    acoes: [
      { rotulo: 'Cancelar', classe: 'btn' },
      { rotulo: 'Inativar', classe: 'btn btn--primario', onClick: async () => {
        const novo = picker.getValue();
        const { error } = await supabase.rpc('inativar_empregador', { p_origem: emp.id, p_destino: novo || null });
        if (error) {
          const dup = /duplicate key|unique/i.test(error.message || '');
          toast(dup
            ? 'Não foi possível reatribuir: há colaborador(es) com a mesma matrícula já cadastrada na empresa substituta. Resolva os conflitos antes de transferir.'
            : 'Não foi possível inativar: ' + error.message, 'erro');
          return false;
        }
        toast(novo ? `Empresa inativada e ${n} colaborador(es) reatribuído(s).` : 'Empresa inativada.', 'sucesso');
        api.recarregar?.();
        return true;
      } },
    ],
  });
}

export const paginaEmpregadores = crudPage({
  titulo: 'Empregadores', singular: 'empregador',
  subtitulo: 'Empresas/instituições vinculadas aos colaboradores. O número entre parênteses é a quantidade de colaboradores cadastrados.',
  tabela: 'empregador',
  ordenarPor: 'empresa',
  enriquecer: enriquecerContagem,
  colunas: [
    { chave: 'empresa', rotulo: 'Empresa', render: (l) => `${l.empresa} (${l._count ?? 0})` },
    { chave: 'cnpj', rotulo: 'CNPJ' },
    { chave: 'proprio', rotulo: 'Tipo', ordenavel: false, render: (l) => l.proprio ? 'Própria (HU/UFRN)' : 'Terceirizada' },
    { chave: 'status', rotulo: 'Status', render: (l) => badgeStatus(l.status) },
  ],
  buscarEm: ['empresa', 'cnpj'],
  acoesLinha: (l, api) => (ehGestaoAtivo() && l.status === 'ATIVO')
    ? [el('button', { class: 'btn', title: 'Inativar / substituir empresa', 'aria-label': 'Inativar empresa', onClick: () => inativarSubstituir(l, api) }, [el('i', { class: 'ph ph-arrows-left-right' })])]
    : [],
  campos: [
    { chave: 'empresa', rotulo: 'Empresa', obrigatorio: true, cheio: true },
    { chave: 'cnpj', rotulo: 'CNPJ', obrigatorio: true, mascara: 'cnpj' },
    { chave: 'proprio', rotulo: 'Instituição própria (HU/UFRN)?', tipo: 'select', opcoes: [{ value: 'true', label: 'Sim' }, { value: 'false', label: 'Não' }], padrao: 'false', normalizar: (v) => v === 'true' },
    { chave: 'status', rotulo: 'Status', tipo: 'select', opcoes: OPCOES_STATUS, padrao: 'ATIVO', cheio: true },
  ],
});